"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["options", "linkComponent", "links", "title"],
    _excluded2 = ["label"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: _defineProperty({
      width: "100%"
    }, theme.breakpoints.up("md"), {
      paddingBottom: "0.5rem"
    }),
    list: _defineProperty({
      listStyle: "none",
      padding: 0,
      paddingTop: "1rem",
      "& > li": {
        marginTop: "2.3125rem"
      }
    }, theme.breakpoints.up("md"), {
      "& > li": {
        marginTop: "1.5rem"
      }
    }),
    link: _objectSpread(_objectSpread({}, theme.typography.caption), {}, {
      textDecoration: "none"
    }),
    title: {
      lineHeight: "inherit"
    }
  };
});

function QuickLinks(_ref) {
  var options = _ref.options,
      linkComponent = _ref.linkComponent,
      links = _ref.links,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles(props);
  var LinkComponent = linkComponent || _core.Link;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: options.title.variant,
    className: classes.title
  }, title), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: options.link.variant,
    className: (0, _clsx["default"])([classes.text, classes.list]),
    component: "ul"
  }, links.map(function (_ref2) {
    var label = _ref2.label,
        others = _objectWithoutProperties(_ref2, _excluded2);

    return /*#__PURE__*/_react["default"].createElement("li", {
      key: label
    }, /*#__PURE__*/_react["default"].createElement(LinkComponent, _extends({}, others, {
      color: options.link.color,
      variant: options.link.variant,
      underline: "none",
      className: classes.link
    }), label));
  })));
}

QuickLinks.propTypes = {
  linkComponent: _propTypes["default"].elementType,
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({}).isRequired).isRequired,
  options: _propTypes["default"].shape({
    link: _propTypes["default"].shape({
      color: _propTypes["default"].string,
      variant: _propTypes["default"].string
    }),
    title: _propTypes["default"].shape({
      color: _propTypes["default"].string,
      variant: _propTypes["default"].string
    })
  }),
  title: _propTypes["default"].string.isRequired
};
QuickLinks.defaultProps = {
  linkComponent: undefined,
  options: {
    link: {
      color: "textSecondary",
      variant: "caption"
    },
    title: {
      color: "textSecondary",
      variant: "caption"
    }
  }
};
var _default = QuickLinks;
exports["default"] = _default;